<div class="onboarding_wrapper checkout_wrapper section_wrapper">
    <div class="floating_logo">
        <a routerLink="/">
            <img src="assets/images/logos/logo-vertical-light.png"/>
        </a>
    </div>

    <div class="floating_skip">
        <a class="skip" routerLink="/">Skip</a>
    </div>

    <div class="bg_image"></div>
    <!-- end bg_image -->
    <div class="bg_image mob"></div>
    <!-- end bg_image -->

    <div class="onboard_wrap">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="heading">Almost there!</h2>
                <div class="subheading">
                    <p>
                        You're one step away from joining Australia's latest, new and improved racing insight and
                        analysis platform!
                    </p>
                </div>
            </div>
            <!-- end col-12 -->
        </div>
        <!-- end row -->

        <div class="row checkout_row" *ngIf="!feature_loading && !cards_loading">
            <div class="col-xl-8 col-lg-7 col_details" *ngIf="!cards || cards?.length == 0">
                <div class="panel">
                    <div class="row_header">
                        <div class="col-12">
                            <h2 class="heading">Payment details</h2>

                            <div class="svg_wrapper">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="123.995"
                                    height="35.077"
                                    viewBox="0 0 123.995 35.077"
                                >
                                    <g id="Group_9236" data-name="Group 9236" transform="translate(-989.913 -268.715)">
                                        <path
                                            id="Path_8404"
                                            data-name="Path 8404"
                                            d="M2.843-.329c1.34,0,2.267-.731,2.267-1.883,0-1.265-1.077-1.6-2.22-1.977-.918-.29-1.377-.515-1.377-1.124S2-6.287,2.7-6.287a1.526,1.526,0,0,1,1.49,1.012L4.922-5.7A2.357,2.357,0,0,0,2.7-7.13,1.893,1.893,0,0,0,.641-5.275c0,1.218,1.012,1.546,2.061,1.883.965.3,1.546.525,1.546,1.2,0,.59-.459,1.012-1.387,1.012a1.674,1.674,0,0,1-1.752-1.19L.36-1.94A2.462,2.462,0,0,0,2.843-.329Zm3.9-2.089h3.925a2.4,2.4,0,0,0,.028-.365A2.359,2.359,0,0,0,8.361-5.256,2.379,2.379,0,0,0,5.906-2.792,2.389,2.389,0,0,0,8.417-.329a2.364,2.364,0,0,0,2.061-1.059l-.693-.393A1.529,1.529,0,0,1,8.436-1.1,1.6,1.6,0,0,1,6.74-2.418Zm1.621-2.07A1.484,1.484,0,0,1,9.869-3.13H6.74A1.555,1.555,0,0,1,8.361-4.488Zm5.462,4.16A2.373,2.373,0,0,0,15.93-1.546l-.693-.4a1.571,1.571,0,0,1-1.415.815,1.624,1.624,0,0,1-1.649-1.658A1.626,1.626,0,0,1,13.822-4.46a1.5,1.5,0,0,1,1.387.824l.684-.393a2.252,2.252,0,0,0-2.07-1.227,2.415,2.415,0,0,0-2.464,2.464A2.415,2.415,0,0,0,13.822-.329Zm6.155-4.806v2.483c0,1.105-.609,1.546-1.358,1.546a1.08,1.08,0,0,1-1.162-1.2V-5.135h-.815v2.876A1.749,1.749,0,0,0,18.46-.329a1.665,1.665,0,0,0,1.518-.8V-.45h.815V-5.135Zm2.867.787v-.787h-.815V-.45h.815V-2.933a1.31,1.31,0,0,1,1.461-1.433v-.853A1.487,1.487,0,0,0,22.844-4.348Zm2.576,1.93h3.925a2.4,2.4,0,0,0,.028-.365,2.359,2.359,0,0,0-2.333-2.473,2.379,2.379,0,0,0-2.455,2.464A2.389,2.389,0,0,0,27.1-.329a2.364,2.364,0,0,0,2.061-1.059l-.693-.393a1.529,1.529,0,0,1-1.349.684A1.6,1.6,0,0,1,25.42-2.418Zm1.621-2.07A1.484,1.484,0,0,1,28.549-3.13H25.42A1.555,1.555,0,0,1,27.041-4.488Zm7.139-2.52v2.679a2.026,2.026,0,0,0-1.771-.927,2.406,2.406,0,0,0-2.37,2.464,2.406,2.406,0,0,0,2.37,2.464,2.026,2.026,0,0,0,1.771-.927V-.45h.815V-7.008ZM32.512-1.116a1.636,1.636,0,0,1-1.658-1.677,1.636,1.636,0,0,1,1.658-1.677A1.638,1.638,0,0,1,34.18-2.792,1.638,1.638,0,0,1,32.512-1.116Zm8.647-4.141a2.026,2.026,0,0,0-1.771.927V-7.008h-.815V-.45h.815v-.806a2.026,2.026,0,0,0,1.771.927,2.406,2.406,0,0,0,2.37-2.464A2.406,2.406,0,0,0,41.159-5.256Zm-.1,4.141a1.638,1.638,0,0,1-1.668-1.677,1.638,1.638,0,0,1,1.668-1.677,1.636,1.636,0,0,1,1.658,1.677A1.636,1.636,0,0,1,41.056-1.116Zm6.53-4.019L46.237-1.462,44.644-5.135h-.871L45.815-.469l-.084.178a1.24,1.24,0,0,1-1.265.956v.759A2.079,2.079,0,0,0,46.546-.16l1.911-4.975Z"
                                            transform="translate(1017.354 282.369)"
                                        />
                                        <path
                                            id="Path_8402"
                                            data-name="Path 8402"
                                            d="M15.5,11.331c0,1.562-.841,4.084-1.922,6.847.961,2.4,2.282,5.045,3.484,7.448,2.763-5.286,5.406-11.292,5.406-14.295a10.931,10.931,0,1,0-21.863,0c0,5.766,9.97,22.584,10.931,24.145.36-.6,1.8-3,3.484-6.126-3.243-5.886-7.328-14.295-7.328-18.019a3.975,3.975,0,0,1,3.964-3.844A3.8,3.8,0,0,1,15.5,11.331Z"
                                            transform="translate(989.313 268.315)"
                                            fill="#c11"
                                            fill-rule="evenodd"
                                        />
                                        <path
                                            id="Path_8403"
                                            data-name="Path 8403"
                                            d="M31.079,12.659a3.007,3.007,0,0,0,.807-.073l.66-.22a.986.986,0,0,0,.44-.513,1.45,1.45,0,0,0,.147-.807,2.263,2.263,0,0,0-.147-.807,3.189,3.189,0,0,0-.44-.513,1.183,1.183,0,0,0-.66-.22,2.749,2.749,0,0,0-.807-.073H29.246v3.226Zm.66-5.059a4.437,4.437,0,0,1,1.76.293,3.35,3.35,0,0,1,1.173.807,2.761,2.761,0,0,1,.66,1.1,3.835,3.835,0,0,1,.22,1.32,3.425,3.425,0,0,1-.22,1.246,2.761,2.761,0,0,1-.66,1.1,3.666,3.666,0,0,1-1.173.807,4.006,4.006,0,0,1-1.76.293H29.246v3.886H26.9V7.6ZM36.5,18.378h2.126V10.533H36.5Zm0-9.018h2.126V7.6H36.5Zm5.865,1.173v1.1h.073a3.417,3.417,0,0,1,1.026-1.026,2.876,2.876,0,0,1,1.32-.293,3.7,3.7,0,0,1,1.393.22,2,2,0,0,1,.88.66,2.19,2.19,0,0,1,.44,1.026,6.576,6.576,0,0,1,.147,1.32v4.839H45.523v-4.4a2.74,2.74,0,0,0-.293-1.466,1.287,1.287,0,0,0-1.1-.44,1.342,1.342,0,0,0-1.246.513,2.749,2.749,0,0,0-.367,1.686v4.106H40.391V10.533h1.98m15.617,2.126a3.007,3.007,0,0,0,.806-.073l.66-.22a.986.986,0,0,0,.44-.513,1.45,1.45,0,0,0,.147-.807,2.263,2.263,0,0,0-.147-.807,3.189,3.189,0,0,0-.44-.513,1.183,1.183,0,0,0-.66-.22,2.749,2.749,0,0,0-.806-.073H56.154v3.226Zm.66-5.059a4.437,4.437,0,0,1,1.76.293A3.35,3.35,0,0,1,61.58,8.7a2.761,2.761,0,0,1,.66,1.1,3.834,3.834,0,0,1,.22,1.32,3.425,3.425,0,0,1-.22,1.246,2.761,2.761,0,0,1-.66,1.1,3.666,3.666,0,0,1-1.173.807,4.006,4.006,0,0,1-1.76.293H56.154v3.886H53.808V7.6Zm9.018,7.112c-.147.073-.293.073-.44.147-.147,0-.293.073-.513.073-.147,0-.367.073-.513.073a1.042,1.042,0,0,0-.44.147l-.44.22c-.147.073-.22.22-.293.293a1.087,1.087,0,0,0-.073.513,1.087,1.087,0,0,0,.073.513.572.572,0,0,0,.293.293,1.042,1.042,0,0,0,.44.147c.147,0,.293.073.513.073a1.664,1.664,0,0,0,.953-.22,1.713,1.713,0,0,0,.513-.513,1.916,1.916,0,0,0,.22-.587c0-.22.073-.367.073-.513v-.807c-.147.073-.22.147-.367.147m-4.252-3.006a2.331,2.331,0,0,1,.88-.807,3.239,3.239,0,0,1,1.173-.44,8.079,8.079,0,0,1,1.32-.147,6.307,6.307,0,0,1,1.173.073,3.97,3.97,0,0,1,1.1.293,2.292,2.292,0,0,1,.806.66,1.86,1.86,0,0,1,.293,1.173v4.106a4.84,4.84,0,0,0,.073,1.026,4.556,4.556,0,0,0,.22.733h-2.2a.661.661,0,0,1-.073-.367c0-.147-.073-.22-.073-.367a2.69,2.69,0,0,1-1.246.733,4.6,4.6,0,0,1-1.393.22,4.327,4.327,0,0,1-1.026-.147,2.478,2.478,0,0,1-.88-.44,2.871,2.871,0,0,1-.587-.733,2.342,2.342,0,0,1-.22-1.026,2.448,2.448,0,0,1,.22-1.1,1.731,1.731,0,0,1,.587-.66,2.447,2.447,0,0,1,.88-.367c.293-.073.66-.147.953-.22s.66-.073.953-.147a2.636,2.636,0,0,0,.807-.147,1.474,1.474,0,0,0,.587-.293.666.666,0,0,0,.22-.513,1.381,1.381,0,0,0-.147-.587.572.572,0,0,0-.293-.293,1.042,1.042,0,0,0-.44-.147c-.147,0-.367-.073-.513-.073A1.551,1.551,0,0,0,65.539,12a1.435,1.435,0,0,0-.44.88H62.973a2.8,2.8,0,0,1,.44-1.173M74.7,20.724a2.968,2.968,0,0,1-1.76.44h-.66a2.03,2.03,0,0,1-.66-.073v-1.76c.22,0,.44.073.587.073h.66a.77.77,0,0,0,.66-.367,1.183,1.183,0,0,0,.22-.66,1.248,1.248,0,0,0-.073-.513l-2.713-7.332h2.273L75,15.885h0l1.686-5.352h2.2l-3.3,8.8a2.113,2.113,0,0,1-.88,1.393m7.039-10.191v1.026h0a2.554,2.554,0,0,1,1.026-.953,2.808,2.808,0,0,1,1.393-.367,2.511,2.511,0,0,1,1.32.293,1.879,1.879,0,0,1,.953,1.026,2.228,2.228,0,0,1,.953-.88,2.213,2.213,0,0,1,1.393-.367,5.7,5.7,0,0,1,1.173.147,1.76,1.76,0,0,1,.88.513,2.636,2.636,0,0,1,.587.88,3.552,3.552,0,0,1,.22,1.32v5.206H89.514V13.246a1.381,1.381,0,0,0-.147-.587,1.944,1.944,0,0,0-.367-.44,1.84,1.84,0,0,0-.733-.147,2.169,2.169,0,0,0-.733.147,1.245,1.245,0,0,0-.44.44,6.923,6.923,0,0,0-.22.66c0,.22-.073.44-.073.733v4.326H84.675V13.319a2.141,2.141,0,0,0-.147-.66.751.751,0,0,0-.367-.44c-.147-.147-.44-.147-.807-.147a.8.8,0,0,0-.367.073,4.206,4.206,0,0,0-.513.293,1.315,1.315,0,0,0-.367.513,1.733,1.733,0,0,0-.147.953v4.546H79.836V10.533h1.906m16.2,1.833a1.548,1.548,0,0,0-1.173-.44,2.735,2.735,0,0,0-.88.147,1.59,1.59,0,0,0-.513.44,1.837,1.837,0,0,0-.293.513,1.431,1.431,0,0,0-.073.513h3.519a8.708,8.708,0,0,0-.587-1.173m-2.493,4.106a1.985,1.985,0,0,0,1.393.44,1.767,1.767,0,0,0,1.1-.293,1.588,1.588,0,0,0,.587-.66h1.906a3.164,3.164,0,0,1-1.393,1.98,3.905,3.905,0,0,1-2.273.587,4.3,4.3,0,0,1-1.686-.293,5.22,5.22,0,0,1-1.246-.807,3.991,3.991,0,0,1-.807-1.32,4.075,4.075,0,0,1-.293-1.686,3.946,3.946,0,0,1,.293-1.613,3.991,3.991,0,0,1,.807-1.32,4.817,4.817,0,0,1,1.246-.88,3.946,3.946,0,0,1,1.613-.293,4.43,4.43,0,0,1,1.76.367,4.249,4.249,0,0,1,1.246,1.026,5.292,5.292,0,0,1,.66,1.466,4.653,4.653,0,0,1,.147,1.76H94.866a3.058,3.058,0,0,0,.587,1.54m8.358-5.939v1.1h.073a3.417,3.417,0,0,1,1.026-1.026,2.876,2.876,0,0,1,1.32-.293,3.7,3.7,0,0,1,1.393.22,2,2,0,0,1,.88.66,2.19,2.19,0,0,1,.44,1.026,6.577,6.577,0,0,1,.147,1.32v4.839h-2.126v-4.4a2.74,2.74,0,0,0-.293-1.466,1.287,1.287,0,0,0-1.1-.44,1.342,1.342,0,0,0-1.246.513,2.749,2.749,0,0,0-.367,1.686v4.106h-2.126V10.533h1.98m11.291,0V12h-1.613v3.886a1.577,1.577,0,0,0,.147.733c.147.147.367.147.733.147h.367c.147,0,.22,0,.293-.073v1.686c-.147,0-.367.073-.587.073h-.66a3.873,3.873,0,0,1-.953-.073,2.626,2.626,0,0,1-.807-.293,1.017,1.017,0,0,1-.513-.587,1.834,1.834,0,0,1-.22-.953V11.926h-1.32V10.459h1.32V8.113h2.126v2.346H115.1m2.786,5.939a1.944,1.944,0,0,0,.367.44,1.1,1.1,0,0,0,.513.22,1.614,1.614,0,0,0,.587.073.93.93,0,0,0,.44-.073,1.042,1.042,0,0,0,.44-.147,1.287,1.287,0,0,0,.367-.293,1.042,1.042,0,0,0,.147-.44.83.83,0,0,0-.66-.733c-.44-.147-1.026-.293-1.76-.513l-.88-.22a2.71,2.71,0,0,1-.806-.367,2.231,2.231,0,0,1-.587-.587,1.564,1.564,0,0,1-.22-.88,2.1,2.1,0,0,1,.293-1.246,1.95,1.95,0,0,1,.806-.733,2.442,2.442,0,0,1,1.1-.367,5.371,5.371,0,0,1,2.493,0,3.456,3.456,0,0,1,1.1.44,3.843,3.843,0,0,1,.806.733,2.028,2.028,0,0,1,.367,1.173h-2.053a.9.9,0,0,0-.44-.807,2.129,2.129,0,0,0-1.026-.22h-.367a3.176,3.176,0,0,0-.367.073,1.012,1.012,0,0,0-.293.22.56.56,0,0,0-.147.367.443.443,0,0,0,.22.44,1.1,1.1,0,0,0,.587.293c.22.073.513.147.807.22l.88.22a4.133,4.133,0,0,1,.88.293,2.71,2.71,0,0,1,.807.367,2.231,2.231,0,0,1,.587.587,1.742,1.742,0,0,1,.22.88,2.511,2.511,0,0,1-.293,1.32,1.72,1.72,0,0,1-.806.807,3.239,3.239,0,0,1-1.173.44,6.012,6.012,0,0,1-2.639,0,3.239,3.239,0,0,1-1.173-.44,2.814,2.814,0,0,1-.807-.807,2.532,2.532,0,0,1-.367-1.32h2.053a.559.559,0,0,0,0,.587"
                                            transform="translate(990.814 280.062)"
                                            fill="#567"
                                            fill-rule="evenodd"
                                        />
                                    </g>
                                </svg>
                            </div>
                            <!-- end svg_wrapper -->
                        </div>
                        <!-- end col-12 -->
                    </div>
                    <!-- end row_header -->

                    <div class="supported_cards col-12">
                        <img src="/assets/images/icons/payment-cards.svg" />
                    </div>
                    <!-- end inner -->

                    <form class="form_wrapper" [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label>Name on card</label>
                                <input
                                    id="name"
                                    formControlName="name"
                                    maxlength="20"
                                    type="text"
                                    class="form-control"
                                    placeholder="Full name"
                                />
                                <div *ngIf="submitted && f.name.errors" class="text-danger">
                                    <div *ngIf="f.name.errors.required">Name is required</div>
                                    <div *ngIf="f.name.errors.pattern">Name is not valid</div>
                                </div>
                                <div
                                    *ngIf="submitted && pinpayment_response && pinpayment_response.error"
                                    class="text-danger"
                                >
                                    <div *ngIf="pinpayment_errors.name">{{ pinpayment_errors.name }}</div>
                                </div>
                            </div>

                            <div class="form-group col-12">
                                <label>Card number</label>
                                <input
                                    id="number"
                                    type="text"
                                    formControlName="number"
                                    pattern="[0-9]*"
                                    class="form-control"
                                    placeholder="Card Number"
                                    inputmode="numeric"
                                />
                                <div *ngIf="submitted && f.number.errors" class="text-danger">
                                    <div *ngIf="f.number.errors.required">Card Number is required</div>
                                    <div *ngIf="f.number.errors.pattern">Number is not valid</div>
                                </div>
                                <div
                                    *ngIf="submitted && pinpayment_response && pinpayment_response.error"
                                    class="text-danger"
                                >
                                    <div *ngIf="pinpayment_errors.number">{{ pinpayment_errors.number }}</div>
                                </div>
                            </div>

                            <div class="form-group col-lg-4 col-md-4">
                                <label>Expiry</label>
                                <div class="select_wrap grey">
                                    <select id="expiry_month" formControlName="expiry_month" class="form-control">
                                        <option value="">Expiry Month</option>
                                        <option value="01">Jan</option>
                                        <option value="02">Feb</option>
                                        <option value="03">Mar</option>
                                        <option value="04">Apr</option>
                                        <option value="05">May</option>
                                        <option value="06">Jun</option>
                                        <option value="07">Jul</option>
                                        <option value="08">Aug</option>
                                        <option value="09">Sep</option>
                                        <option value="10">Oct</option>
                                        <option value="11">Nov</option>
                                        <option value="12">Dec</option>
                                    </select>
                                </div>
                                <div *ngIf="submitted && f.expiry_month.errors" class="text-danger">
                                    <div *ngIf="f.expiry_month.errors.required">Expiry Month is required</div>
                                    <div *ngIf="f.expiry_month.errors.pattern">Expiry Month is not valid</div>
                                </div>
                                <div
                                    *ngIf="submitted && pinpayment_response && pinpayment_response.error"
                                    class="form-control"
                                    class="text-danger"
                                >
                                    <div *ngIf="pinpayment_errors.expiry_month">
                                        {{ pinpayment_errors.expiry_month }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-4 col-md-4 no_label">
                                <div class="select_wrap grey">
                                    <select id="expiry_year" formControlName="expiry_year" class="form-control">
                                        <option value="">Expiry Year</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                        <option value="2031">2031</option>
                                        <option value="2032">2032</option>
                                        <option value="2033">2033</option>
                                        <option value="2033">2033</option>
                                        <option value="2033">2033</option>
                                        <option value="2036">2036</option>
                                    </select>
                                </div>
                                <!-- <input  type="text"  pattern="[0-9]*" class="form-control" placeholder="Expiry Year" inputmode="numeric"> -->
                                <div *ngIf="submitted && f.expiry_year.errors" class="text-danger">
                                    <div *ngIf="f.expiry_year.errors.required">Expiry Year is required</div>
                                    <div *ngIf="f.expiry_year.errors.pattern">Expiry Year is not valid</div>
                                </div>
                                <div
                                    *ngIf="submitted && pinpayment_response && pinpayment_response.error"
                                    class="form-control"
                                    class="text-danger"
                                >
                                    <div *ngIf="pinpayment_errors.expiry_year">{{ pinpayment_errors.expiry_year }}</div>
                                </div>
                            </div>

                            <div class="form-group col-lg-4 col-md-4">
                                <label
                                    >CVC
                                    <div class="svg_wrapper" placement="top" ngbTooltip="3 digits on back of card">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                        >
                                            <g
                                                id="Group_9217"
                                                data-name="Group 9217"
                                                transform="translate(-856.444 -582.5)"
                                            >
                                                <circle
                                                    id="Ellipse_181"
                                                    data-name="Ellipse 181"
                                                    cx="8"
                                                    cy="8"
                                                    r="8"
                                                    transform="translate(856.444 582.5)"
                                                />
                                                <path
                                                    id="_mo."
                                                    data-name="/ mo."
                                                    d="M2.227-6.623H3.1c0-1.2,1.733-1.554,1.733-3.005A1.843,1.843,0,0,0,2.8-11.408,2.1,2.1,0,0,0,.72-10.061l.744.414a1.285,1.285,0,0,1,1.328-.914c.659,0,1.168.311,1.168.97C3.961-8.469,2.227-8.139,2.227-6.623Zm.433,2.035A.605.605,0,0,0,3.273-5.2a.605.605,0,0,0-.612-.612.611.611,0,0,0-.612.612A.611.611,0,0,0,2.661-4.588Z"
                                                    transform="translate(861.666 598.382)"
                                                    fill="#fff"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <!-- end svg_wrapper -->
                                </label>
                                <input
                                    id="cvc"
                                    formControlName="cvc"
                                    placeholder="CVC"
                                    type="text"
                                    pattern="[0-9]*"
                                    class="form-control"
                                    inputmode="numeric"
                                />
                                <div *ngIf="submitted && f.cvc.errors" class="text-danger">
                                    <div *ngIf="f.cvc.errors.required">CVC is required</div>
                                    <div *ngIf="f.cvc.errors.pattern">CVC is not valid</div>
                                </div>
                                <div
                                    *ngIf="submitted && pinpayment_response && pinpayment_response.error"
                                    class="text-danger"
                                >
                                    <div *ngIf="pinpayment_errors.cvc">{{ pinpayment_errors.cvc }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- end form-row -->

                        <div *ngIf="submitted && pinpayment_response && pinpayment_response.error" class="text-danger">
                            <div>{{ pinpayment_response.error_description }}</div>
                        </div>

                        <div class="col_btn align-self-center text-right">
                            <button (click)="onSubmit()" class="btn large" [disabled]="loading">
                                Subscribe <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            </button>
                        </div>
                    </form>
                    <!-- end form_wrapper -->
                </div>
                <!-- end panel -->
            </div>
            <!-- end col-md-7 -->

            <div class="col-xl-8 col-lg-7 col_details cards_exist" *ngIf="cards && cards?.length > 0">

                <div class="panel">
                    <div class="row_header">
                        <div class="col-12">
                            <h2 class="heading">Choose a payment method</h2>

                            
                        </div>
                        <!-- end col-12 -->
                    </div>
                    <!-- end row_header -->


                    <div class="col-lg-12">
                    
                        <div
                            class="panel black"
                            *ngFor="let card of cards"
                            [ngClass]="{ active: payment_method && payment_method?.id === card.id }"
                            (click)="selectPaymentMethod(card)"
                        >
                            <div class="c_card">
                            
                                <div class="card_head">
                                    <div class="badge_wrap" *ngIf="card?.primary">
                                        <div class="badge light_blue">
                                            <span>Primary</span>
                                        </div>
                                        <!-- end badge -->
                                    </div>
                                    <!-- end badge_wrap -->
                                </div>
                                <!-- end card_head -->

                                <div class="card_details">
                                    <div class="svg_wrapper">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="42.345"
                                            height="13.738"
                                            viewBox="0 0 42.345 13.738"
                                        >
                                            <g
                                                id="Group_9241"
                                                data-name="Group 9241"
                                                transform="translate(-458.861 -392.397)"
                                            >
                                                <g
                                                    id="Group_9220"
                                                    data-name="Group 9220"
                                                    transform="translate(458.861 392.397)"
                                                >
                                                    <g id="Group_9219" data-name="Group 9219" transform="translate(0 0)">
                                                        <path
                                                            id="Path_8405"
                                                            data-name="Path 8405"
                                                            d="M56.657,65.458H53.2l2.16-13.272h3.455Z"
                                                            transform="translate(-38.301 -51.949)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_8406"
                                                            data-name="Path 8406"
                                                            d="M23.222,52.187l-3.294,9.128-.389-1.966h0l-1.163-5.968a1.479,1.479,0,0,0-1.639-1.2H11.291l-.064.224a12.908,12.908,0,0,1,3.614,1.518l3,11.53h3.6l5.5-13.272Z"
                                                            transform="translate(-11.227 -51.95)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_8407"
                                                            data-name="Path 8407"
                                                            d="M105,65.459h3.173l-2.766-13.272h-2.778a1.588,1.588,0,0,0-1.6.989L95.881,65.459h3.6l.721-1.971H104.6Zm-3.8-4.695,1.816-4.967,1.021,4.967Z"
                                                            transform="translate(-65.828 -51.95)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_8408"
                                                            data-name="Path 8408"
                                                            d="M78.769,54.947l.493-2.85a9.973,9.973,0,0,0-3.108-.579c-1.715,0-5.786.75-5.786,4.394,0,3.429,4.779,3.472,4.779,5.272s-4.286,1.479-5.7.343l-.514,2.98a9.678,9.678,0,0,0,3.9.75c2.358,0,5.915-1.222,5.915-4.544,0-3.451-4.822-3.772-4.822-5.272S77.291,54.132,78.769,54.947Z"
                                                            transform="translate(-48.446 -51.518)"
                                                            fill="#fff"
                                                        />
                                                    </g>
                                                    <path
                                                        id="Path_8409"
                                                        data-name="Path 8409"
                                                        d="M19.538,59.35l-1.163-5.968a1.479,1.479,0,0,0-1.639-1.2H11.291l-.064.224a13.4,13.4,0,0,1,5.128,2.575A10.351,10.351,0,0,1,19.538,59.35Z"
                                                        transform="translate(-11.227 -51.95)"
                                                        fill="#fff"
                                                    />
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <!-- end svg_wrapper -->

                                    <div class="last_digits">
                                        <span class="stars">****</span>
                                        <span class="digits">{{ card?.display_number.slice(-4) }}</span>
                                    </div>
                                    <!-- end last_digits -->
                                </div>
                                <!-- end card_details -->

                            </div><!-- end c_card -->
                            
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end panel -->

                    <div class="button">
                        <a (click)="addCard()" class="btn large">Add Payment Method</a>
                    </div>
                </div>
                <!-- end col-md-4 -->
            </div>
            <!-- end col-md-7 -->

            <div class="col-xl-4 col-lg-5 col_cart">
                <div class="panel">
                    <div class="row_header">
                        <div class="col-12">
                            <h2 class="heading">Cart</h2>

                            <a class="edit" routerLink="/subscribe-plan">Edit</a>
                        </div>
                        <!-- end col-12 -->
                    </div>
                    <!-- end row_header -->

                    <div class="cart_items">
                        <ul class="features" *ngIf="!selected_plan?.premium_plan">
                            <li *ngFor="let row of selected_plan?.selected_features; let i = index">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                                    <g id="Group_9240" data-name="Group 9240" transform="translate(-765.75 -788.746)">
                                        <rect
                                            id="Background"
                                            width="19"
                                            height="19"
                                            rx="9.5"
                                            transform="translate(765.75 788.746)"
                                            fill="#6cfcfd"
                                        />
                                        <path
                                            id="Path_8393"
                                            data-name="Path 8393"
                                            d="M2.643,7.738,5.05,5.211,0,0"
                                            transform="translate(779.119 795.685) rotate(90)"
                                            fill="none"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.5"
                                        />
                                    </g>
                                </svg>
                                <span class="title">{{ row.title }}</span>
                                <span class="price"
                                    >${{ row?.selected_plan.price | number: '1.0-2' }} p/{{
                                        row?.selected_plan.duration | slice: 0:1
                                    }}</span
                                >
                            </li>
                        </ul>

                        <ul class="features" *ngIf="selected_plan?.premium_plan">
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                                    <g id="Group_9240" data-name="Group 9240" transform="translate(-765.75 -788.746)">
                                        <rect
                                            id="Background"
                                            width="19"
                                            height="19"
                                            rx="9.5"
                                            transform="translate(765.75 788.746)"
                                            fill="#6cfcfd"
                                        />
                                        <path
                                            id="Path_8393"
                                            data-name="Path 8393"
                                            d="M2.643,7.738,5.05,5.211,0,0"
                                            transform="translate(779.119 795.685) rotate(90)"
                                            fill="none"
                                            stroke="#000"
                                            stroke-miterlimit="10"
                                            stroke-width="1.5"
                                        />
                                    </g>
                                </svg>
                                <span class="title">{{ selected_plan?.title }}</span>
                                <span class="price"
                                    >${{ selected_plan?.duration.price | number: '1.0-2' }} p/{{
                                        selected_plan?.duration.duration | slice: 0:1
                                    }}</span
                                >
                            </li>
                        </ul>
                    </div>
                    <!-- end cart_items -->



                    <div class="cart_total">

                        <div class="coupon_form" *ngIf="showCouponForm">
                            <div class="form_wrapper">
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <div *ngIf="couponCodeError" class="alert alert-danger mt-3">
                                            {{ couponCodeError }}
                                        </div>
                                    </div>
        
                                    <div class="form-group col-12">
                                        <label>Coupon Code</label>
                                        <div class="input-wrap">
                                            <input
                                                id="coupon"
                                                type="text"
                                                class="form-control"
                                                [(ngModel)]="couponCode" 
                                                placeholder="Coupon Code"
                                                [readonly]="couponApplied"
                                            />
                                            <div class="checkmark" *ngIf="couponApplied"></div>
                                        </div>
                                    </div>
                                </div>
                                <button class="black_fill btn btn-block" type="button" *ngIf="!couponApplied" [disabled]="!couponCode" (click)="handleCoupon()">Apply Coupon</button>
                                <button class="blue_outline btn btn-block" type="button" *ngIf="couponApplied" (click)="handleCoupon(false)">Remove Coupon</button>
                            </div>
                        </div>

                        <div class="coupon_form">
                            <a class="edit" (click)="toggleCouponForm()">
                                <span *ngIf="!showCouponForm">Do you have a coupon?</span>
                                <span *ngIf="showCouponForm">Hide Coupon</span>
                            </a>
                        </div>
                        <div class="totals">
                            <span class="total">Total:</span>
                            <span class="price" *ngIf="!couponApplied"
                                >${{ selected_plan?.duration.price }} p/{{
                                    selected_plan?.duration.duration | slice: 0:1
                                }}</span
                            >
                            <span class="price" *ngIf="couponApplied"
                            ><del class="ml-2 mr-2">${{ selected_plan?.duration.price | number: '1.0-2' }}</del>${{ selected_plan?.duration.discounted_price | number: '1.0-2' }} p/{{
                                 selected_plan.duration.duration | slice: 0:1
                            }}</span
                            >
                            <span class="total mt-2" *ngIf="selected_plan && selected_plan?.duration.trialDays"
                            > **{{selected_plan?.duration.trialDays}} trial - no charges. Experience product free for {{selected_plan?.duration.trialDays}}!</span
                            >
                            
                        </div>
                        <!-- end totals -->

                        <div
                            class="warning_to_user"
                            *ngIf="
                                user &&
                                user?.subscription && user?.subscription.pricing_plan && 
                                user?.subscription.pricing_plan.id != selected_plan?.duration.id
                            "
                        >
                            <p>
                                Please note: since our payment provider does not facilitate pro rata billing, you will
                                be charged the full amount of your new subscription cost.
                            </p>
                        </div>
                        <!-- end warning_to_user -->

                        <div class="button">
                            <button (click)="onSubmit()" class="btn blue" [disabled]="loading">
                                Subscribe <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            </button>
                        </div>
                        <!-- end button -->
                    </div>
                    <!-- end cart_total -->
                </div>
                <!-- end panel -->
            </div>
            <!-- end col-md-5 -->
        </div>
        <!-- end features_wrapper -->
    </div>
    <!-- end onboard_wrap -->
</div>
<!-- section_wrapper -->

